import { nanoid } from 'nanoid';
import jscookie from 'js-cookie';
import { processEnv } from '@utils/config';

let deviceId = '';
export const getDeviceId = () => {
  if (deviceId) {
    return deviceId;
  }
  deviceId = jscookie.get('bbt_lbu', {
    domain: processEnv.hostEnv == 'test' ? '.meitun-test.com' : '.meitun.com'
  });
  if (deviceId) {
    return deviceId;
  }
  deviceId = nanoid();
  jscookie.set('bbt_lbu', deviceId, {
    expires: 365,
    domain: processEnv.hostEnv == 'test' ? '.meitun-test.com' : '.meitun.com'
  });
  return deviceId;
};
